import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function Banner(props) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Startup">
                <h1>Lean Startup Services</h1>
              </div>
              <p className="main_para">
                Build and manage your startup through shortened product
                development lifecycles
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banner_content_txt">
              <p>
                Our lean startup services enable startups to find the right
                areas that impact consumers the most and allow them to build a
                product or provide the most beneficial services.
              </p>
              <ul>
                <li>Startup Strategy</li>
                <li>Market Surveys</li>
                <li>User-Centric Approach</li>
                <li>Innovation-Focused</li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
